import { createRoute } from '@tanstack/react-router';
import { ReferralsPage } from '@/features/growth/Referrals';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/growth/referrals',
  component: ReferralsPage,
});
